function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.5,
  cy: 45.5,
  r: 21.5,
  fill: "#D76969"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 91.5,
  r: 12,
  fill: "#D79D69"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5 118.25C49.8333 99.5833 60 50.35 90 2.75",
  stroke: "#5CA97B",
  strokeWidth: 10
});

var SvgErrorIcon = function SvgErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 119,
    viewBox: "0 0 95 119",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-icon.306f1fe5.svg";
export { ForwardRef as ReactComponent };